var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inputClass"},[_c('SelectInput',{attrs:{"name":_vm.name,"id":_vm.id,"data":_vm.data,"endpoint":_vm.endpoint,"multiple":_vm.multiple}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }